import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import EndDialogBtn from './EndDialogBtn';

export default class EndDialog extends Phaser.GameObjects.Container {
  constructor(scene, names, msg) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'popup-bg', this).setOrigin(0, 0);

    if (msg === 'nope') {
      const over = ABCyaPhaser.Images.addImage(0, 0, 'game-over', this).setOrigin(0, 0);
      over.x = (this.bg.getBounds().width / 2) - (over.getBounds().width / 2);
      over.y = 40;

      for (let i = 0; i < names.length; i++) {
        const btn = new EndDialogBtn(this.scene, names[i]);
        btn.x = this.bg.getBounds().width / 2;
        btn.y = this.bg.getBounds().height / 2 + (i * (btn.getBounds().height + 20)) + 15;
        this.add(btn);

        btn.hitShape.once('pointerup', () => {this.handleBtnSelect(names[i]);});
      }
    }
    else {
      this.bg.scaleX = 0.7;
      const endTxt = ABCyaPhaser.Text.addText(0, 0, 40, '0xFFFFFF', FontKeys._odin_roundedregular, 'Awesome!\nYou finished the game!', this);
      endTxt.x = (this.bg.getBounds().width / 2) * this.bg.scaleX + 60;
      endTxt.y = 100;

      const btn = new EndDialogBtn(this.scene, names[0]);
      btn.x = this.bg.getBounds().width / 2;
      btn.y = this.bg.getBounds().height / 2 + 30;
      this.add(btn);

      btn.hitShape.once('pointerup', () => {this.handleBtnSelect(names[0]);});
    }


  }

  handleBtnSelect(e) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.emit('DIALOG_SELECT', e);
  };
}